export default __webpack_public_path__ + "stat-meetings.cfb6f9a0.svg";